import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Loader from "../../../Parts/Loader";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    boxSizing: "border-box",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

/**
 * Salesforceの連携中のローディング画面
 */
class SalesforceIntegrateLoading extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Loader type="color" />
        </div>
      </div>
    );
  }
}

SalesforceIntegrateLoading.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesforceIntegrateLoading);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceIntegrateLoading.jsx